import { render, staticRenderFns } from "./sharemanage.vue?vue&type=template&id=3e455bbb&scoped=true&"
import script from "./sharemanage.vue?vue&type=script&lang=js&"
export * from "./sharemanage.vue?vue&type=script&lang=js&"
import style0 from "./sharemanage.vue?vue&type=style&index=0&id=3e455bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e455bbb",
  null
  
)

export default component.exports